import parseISO from 'date-fns/parseISO';
import isWithinInterval from 'date-fns/isWithinInterval';
import { linearChannelsFetchByIdSelector } from 'app-webtech-core/modules/linearChannels/selectors/fetchById';

const findCurrentTimeline = (timelines) => {
  const now = Date.now();

  return (
    timelines.find(({ start, stop }) =>
      isWithinInterval(now, { start: parseISO(start), end: parseISO(stop) }),
    ) || {}
  );
};

const mapLinearChannelToInfoBanner = (id, getState) => {
  const {
    name,
    number,
    summary,
    logo,
    featuredImage,
    slug,
    timelines,
    schedule,
    category,
  } = linearChannelsFetchByIdSelector(getState())(id);

  const { episode = { series: {} }, start, stop } = findCurrentTimeline(
    timelines || schedule || [],
  );

  return {
    channel: {
      name,
      number,
      summary,
      logo,
      featuredImage,
      slug,
      category,
    },
    episode: {
      name: episode.name,
      description: episode.description,
      duration: episode.duration,
      firstAired: episode.firstAired ? parseISO(episode.firstAired) : undefined,
      genre: episode.genre,
      subGenre: episode.subGenre,
      liveBroadcast: episode.liveBroadcast,
    },
    series: {
      name: episode.series.name,
      description: episode.series.description,
      type: episode.series.type,
    },
    start: start ? parseISO(start) : null,
    stop: stop ? parseISO(stop) : null,
  };
};

export default mapLinearChannelToInfoBanner;
